var Modernizr = require('./Modernizr.js');
var createElement = require('./createElement.js');
  /**
   * Create our "modernizr" element that we do most feature tests on.
   *
   * @access private
   */

  var modElem = {
    elem: createElement('modernizr')
  };

  // Clean up this element
  Modernizr._q.push(function() {
    delete modElem.elem;
  });

  module.exports = modElem;




// WEBPACK FOOTER //
// ./project/client/src/core/vendor/browsernizr/lib/modElem.js